"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var constants_1 = require("../constants");
var usePrefixAdornmentStyles = core_1.makeStyles(function () {
    return core_1.createStyles({
        startAdornment: {
            minHeight: constants_1.TEXT_FIELD_HEIGHT,
            backgroundColor: '#F3F3F3',
            // borderRight: 'solid 1px #d8d8d8',
            marginRight: 0,
        },
        startAdornmentText: {
            paddingLeft: 15,
            paddingRight: 26,
        },
    });
});
var PrefixAdornment = function (_a) {
    var children = _a.children;
    var classes = usePrefixAdornmentStyles();
    return (react_1.default.createElement(core_1.InputAdornment, { className: classes.startAdornment, position: "start" },
        react_1.default.createElement(core_1.Typography, { className: classes.startAdornmentText, color: "primary" }, children)));
};
var useTextFieldStyles = core_1.makeStyles(function (theme) {
    var _a, _b;
    return core_1.createStyles({
        textField: (_a = {
                width: '100%',
                marginTop: theme.spacing(1),
                marginBottom: 0,
                borderColor: '#F3F3F3'
            },
            _a[theme.breakpoints.up('md')] = {
            // marginBottom: (props: TextFieldStylesProps) =>
            //   props.multiline ? 0 : -19,
            },
            _a),
        removePrefixPadding: { padding: theme.spacing(0) },
        textInput: (_b = {
                flexGrow: 1,
                height: '100%',
                minHeight: function (props) { return props.textFieldHeight; },
                padding: theme.spacing(0),
                lineHeight: 1.5,
                marginLeft: 14,
                marginRight: 0,
                marginTop: function (props) { return (props.multiline ? 8 : 0); },
                marginBottom: function (props) { return (props.multiline ? 8 : 0); }
            },
            _b[theme.breakpoints.up('md')] = {
                marginRight: 14,
            },
            _b),
        helperText: {
            position: 'absolute',
            top: '100%',
            left: 0,
            width: 'auto',
        },
    });
});
function PrefixableTextField(_a) {
    var value = _a.value, onChange = _a.onChange, placeholder = _a.placeholder, prefix = _a.prefix, _b = _a.error, error = _b === void 0 ? false : _b, _c = _a.helperText, helperText = _c === void 0 ? '' : _c, multiline = _a.multiline, rows = _a.rows, rowsMax = _a.rowsMax, FormHelperTextProps = _a.FormHelperTextProps, _d = _a.disabled, disabled = _d === void 0 ? false : _d;
    var classes = useTextFieldStyles({
        textFieldHeight: constants_1.TEXT_FIELD_HEIGHT,
        multiline: multiline,
    });
    return (react_1.default.createElement(core_1.TextField, { className: classes.textField, error: error, InputProps: {
            className: classes.removePrefixPadding,
            classes: {
                input: classes.textInput,
            },
            startAdornment: prefix && react_1.default.createElement(PrefixAdornment, null, prefix),
        }, required: true, disabled: disabled, variant: "outlined", value: value, onChange: onChange, placeholder: placeholder, helperText: helperText, multiline: multiline, rows: rows, rowsMax: rowsMax, FormHelperTextProps: FormHelperTextProps || { className: classes.helperText } }));
}
exports.default = PrefixableTextField;
